import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import AppsIcon from '@material-ui/icons/Apps';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import { Content, Page } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import {
  HomePageRecentlyVisited,
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageTopVisited,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';

const useStyles = makeStyles(theme => ({
  greetingBlock: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  greetingSub: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  searchBarOuter: {
    display: 'flex',
    justifyContent: 'center',
  },
  searchBar: {
    width: '100%',
    maxWidth: 720,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    boxShadow: 'none',
    padding: '4px 12px',
  },
}));

// RHDH-style time-of-day greeting.
const greetingForNow = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

const useDisplayName = () => {
  const identityApi = useApi(identityApiRef);
  const [name, setName] = React.useState<string>('');

  React.useEffect(() => {
    let mounted = true;
    identityApi.getProfileInfo().then(profile => {
      if (mounted) setName(profile.displayName ?? '');
    });
    return () => {
      mounted = false;
    };
  }, [identityApi]);

  return name;
};

const TOOLS = [
  {
    url: '/catalog',
    label: 'Catalog',
    icon: <AppsIcon />,
  },
  {
    url: '/create',
    label: 'Create',
    icon: <AddBoxIcon />,
  },
  {
    url: '/docs',
    label: 'Docs',
    icon: <ChromeReaderModeIcon />,
  },
  {
    url: '/api-docs',
    label: 'APIs',
    icon: <AccountTreeIcon />,
  },
  {
    url: '/tech-insights',
    label: 'Scorecards',
    icon: <AssessmentIcon />,
  },
];

export const HomePage = () => {
  const classes = useStyles();
  const displayName = useDisplayName();

  return (
    <Page themeId="home">
      <Content>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className={classes.greetingBlock}>
              <Typography variant="h1">
                {greetingForNow()}
                {displayName ? `, ${displayName}` : ''}!
              </Typography>
              <Typography variant="body1" className={classes.greetingSub}>
                Welcome to the Appointy Developer Hub — discover services,
                scaffold new components, and explore docs and APIs.
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} className={classes.searchBarOuter}>
            <HomePageSearchBar
              classes={{ root: classes.searchBar }}
              placeholder="Search"
            />
          </Grid>

          <Grid item xs={12} md={7}>
            <HomePageToolkit title="Quick Access" tools={TOOLS} />
          </Grid>
          <Grid item xs={12} md={5}>
            <HomePageStarredEntities />
          </Grid>

          <Grid item xs={12} md={6}>
            <HomePageRecentlyVisited />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageTopVisited />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
